import { makeStyles } from '@mui/styles';

export const useListStyles = makeStyles({
  listContainer: {
    width: '300px',
    height: '275px',
    overflow: 'auto',
    backgroundColor: '#1a1a1a',
    padding: '16px',
    color: 'white',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#000000',
    zIndex: 1,
    padding: '8px 15px',
  },
  listItemButton: {
    padding: '0',
    backgroundColor: '#3572b0 !important',
    marginBottom: '8px',
    '&:hover': {
      backgroundColor: '#1E5562 !important',
      border: 'none !important',
    },
    border: 'none !important',
    borderRadius: '3px !important',
    height: '40px',
    margin: '10px 0px !important',
  },
  activeListItemButton: {
    backgroundColor: '#1E5562 !important',
  },
  listItemText: {
    color: 'white',
    textAlign: 'center',
  },
  scrollbar: {
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#007BFF',
    },
  },
});
